export default "__VITE_ASSET__51130011__"